<template>
  <div>
    <v-row>
      <v-col>
        <h1 style="color: red">只能上傳.xlsx檔，xls要另存新檔成xlsx</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-file-input
          show-size
          label="天心銷貨單"
          accept=".xlsx"
          v-model="sunlikeFile"
          :disabled="isLoading"
        ></v-file-input>
      </v-col>
      <v-col>
        <v-file-input
          show-size
          label="鼎新銷貨單"
          accept=".xlsx"
          v-model="cosmosFile"
          :disabled="isLoading"
        ></v-file-input>
      </v-col>
      <v-col>
        <v-btn
          color="primary"
          class="mt-3"
          :disabled="!sunlikeFile || !cosmosFile || isLoading"
          :loading="isLoading"
          @click="checkExcel"
        >
          檢查
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { HttpCheckMonthExcelPay } from '@/js/http-Manager'
export default {
  name: 'CheckMonthExcelPay',
  data: () => ({
    sunlikeFile: null,
    cosmosFile: null,
    isLoading: false
  }),
  mounted () {},
  watch: {},
  computed: {},
  methods: {
    async checkExcel () {
      if (this.sunlikeFile && this.cosmosFile) {
        let formData = new FormData()
        formData.append('SunlikeFile', this.sunlikeFile)
        formData.append('CosmosFile', this.cosmosFile)
        this.isLoading = true
        let response = await HttpCheckMonthExcelPay.CheckMonthExcelPay(formData)
        if (response && response.status === 200) {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          })
          const aEle = document.createElement('a') // 創建a標籤
          const href = window.URL.createObjectURL(blob) // 創建下載的鏈接
          aEle.href = href
          aEle.download =
            '對帳單差異_' + this.$moment(new Date()).format('YYYYMMDD_HHmmss') + '.xlsx' // 下載後文件名
          document.body.appendChild(aEle)
          aEle.click() // 點擊下載
          document.body.removeChild(aEle) // 下載完成移除元素
          window.URL.revokeObjectURL(href) // 釋放掉blob對象
        }
        this.isLoading = false
      } else {
        this.$message.error('請上傳天心銷貨單和鼎新銷貨單')
      }
    }
  }
}
</script>
